export function removeCountryFromLocationName(location) {
  return location.name.replace(/, USA$/, '');
}
